<template>
  <section class="hero">
    <div class="hero-body columns is-paddingless is-marginless is-multiline">
      <div v-if="role.admin">
        <div class="field">
          <b-switch
            v-model="userCompanyCheckbox"
            true-value="company"
            false-value="user"
            @input="onChangeUserCompanyCheckbox"
            >{{ userCompanyCheckboxTitle }}</b-switch
          >
        </div>
      </div>
      <div v-if="userCompanyCheckbox === 'company' && role.admin">
        <div class="field">
          <b-switch
            v-model="yesNoAndPointCheckbox"
            true-value="point"
            false-value="yesno"
            @input="onChangeYesNoAndPointCheckbox"
            >{{ yesNoAndPointCheckboxTitle }}</b-switch
          >
        </div>
      </div>
      <div class="column is-4" v-if="role.admin && userCompanyCheckbox === 'user'">
        <b-field>
          <b-checkbox v-model="isAllUsers">{{ $t('title.all') }}</b-checkbox>
          <b-select
            expanded
            v-model="filter.userId"
            @input="onChangeUser"
            :placeholder="$t('validation.attributes.user')"
          >
            <option v-for="option in users" :value="option.id" :key="option.id">
              {{ `${option.firstname} ${option.lastname}` }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div
        class="column is-2"
        v-if="(role.admin || role.company) && userCompanyCheckbox === 'company'"
      >
        <b-field>
          <b-select
            v-model="selectedParentCompanyId"
            expanded
            @input="onChangeParentCompanyUser"
            :placeholder="$t('validation.attributes.company')"
          >
            <option
              v-for="option in parentCompanyUsers"
              :value="option.company.id"
              :key="option.company.id"
              >{{ option.company.name }}</option
            >
          </b-select>
        </b-field>
      </div>
      <div
        class="column is-2"
        v-if="
          (role.admin || role.company) &&
            userCompanyCheckbox === 'company' &&
            yesNoAndPointCheckbox === 'yesno'
        "
      >
        <b-field>
          <b-select
            expanded
            v-model="selectedChildCompanyUserId"
            @input="onChangeCompanyUser"
            :placeholder="$t('validation.attributes.childCompany')"
          >
            <option v-if="role.company" :value="null" selected>
              {{ $t('title.selectChildCompany') }}
            </option>
            <option v-for="option in companyUsers" :value="option.id" :key="option.id">
              {{ option.company.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2" v-if="yesNoAndPointCheckbox === 'yesno'">
        <b-field>
          <b-select
            expanded
            v-model="filter.processId"
            name="process"
            @input="onChangeProcess"
            :placeholder="$t('validation.attributes.process')"
          >
            <option v-for="option in processes" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2" v-if="yesNoAndPointCheckbox === 'point'">
        <b-field>
          <b-select
            expanded
            v-model="selectedParentProcessGroupId"
            name="parentDepartmant"
            @input="onChangeParentProcessGroup"
            :placeholder="$t('validation.attributes.parentDepartmant')"
          >
            <option v-for="option in parentProcessGroups" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2" v-if="yesNoAndPointCheckbox === 'point'">
        <b-field>
          <b-select
            expanded
            v-model="filter.processGroupId"
            name="department"
            @input="onChangeProcessGroup"
            :placeholder="$t('validation.attributes.department')"
          >
            <option v-for="option in childProcessGroups" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div v-if="answerSetVisible" class="column is-2">
        <b-field>
          <b-select
            expanded
            v-model="filter.answerSetId"
            @input="onChangeAnswerSet"
            name="answeredDate"
            :placeholder="$t('validation.attributes.answeredDate')"
          >
            <option v-for="option in answerSetsByProcess" :value="option.id" :key="option.id">
              {{ option.submitDate | datetime }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div v-if="answerSetGroupVisible" class="column is-2">
        <b-field>
          <b-select
            expanded
            v-model="filter.answerSetGroupId"
            @input="onChangeAnswerSetGroup"
            name="answeredDate"
            :placeholder="$t('validation.attributes.answeredDate')"
          >
            <option
              v-for="option in answerSetGroupsByProcessGroup"
              :value="option.id"
              :key="option.id"
            >
              {{ option.submitDate | datetime }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column">
        <b-field grouped>
          <div class="control">
            <button v-if="applyActive" class="button is-primary" @click="apply">
              {{ $t('button.apply') }}
            </button>
            <button v-else class="button is-primary" disabled>{{ $t('button.apply') }}</button>
          </div>
          <slot name="customButtons"></slot>
        </b-field>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import format from 'date-fns/format'
import ApiService from '../../_api/api.service'
import dateSettings from '@/_helpers/date.config'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({
        visibility: {}
      })
    }
  },
  data () {
    return {
      filter: {
        userId: null,
        processId: null,
        processGroupId: null,
        answerSetId: null,
        answerSetGroupId: null,
        content: {
          title: '',
          processName: '',
          processGroupName: ''
        }
      },
      answerSets: [],
      answerSetGroups: [],
      answerSetsByProcess: [],
      answerSetGroupsByProcessGroup: [],
      processes: [],
      processGroups: [],
      parentProcessGroups: [],
      childProcessGroups: [],
      allUsers: [],
      users: [],
      isAllUsers: false,
      companyUsers: [],
      parentCompanyUsers: [],
      userCompanyCheckbox: 'user',
      yesNoAndPointCheckbox: 'yesno',
      userCompanyCheckboxTitle: this.$t('validation.attributes.user'),
      yesNoAndPointCheckboxTitle: this.$t('title.yesNo'),
      selectedParentCompanyId: null,
      selectedChildCompanyUserId: null,
      selectedParentProcessGroupId: null,
      isCompanyAnswerSet: false
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'role']),
    answerSetVisible () {
      return (
        this.yesNoAndPointCheckbox === 'yesno' &&
        (!this.options || !this.options.visibility || this.options.visibility.answerSetId !== false)
      )
    },
    answerSetGroupVisible () {
      return (
        this.yesNoAndPointCheckbox === 'point' &&
        (!this.options ||
          !this.options.visibility ||
          this.options.visibility.answerSetGroupId !== false)
      )
    },
    applyActive () {
      if (this.yesNoAndPointCheckbox === 'point') {
        return (
          this.filter.processGroupId &&
          (!this.answerSetGroupVisible || this.filter.answerSetGroupId)
        )
      } else {
        return this.filter.processId && (!this.answerSetVisible || this.filter.answerSetId)
      }
    }
  },
  async mounted () {
    this.filter.userId = this.currentUser.id
    if (this.role.admin || this.role.company) {
      this.getUsers()
      if (this.currentUser.companyId) {
        this.userCompanyCheckbox = 'company'
        if (this.role.processWithPoint) {
          this.yesNoAndPointCheckbox = 'point'
        }
      }
    }
    if (this.yesNoAndPointCheckbox === 'yesno') {
      await this.getAnswerSets()
    }
  },
  watch: {
    isAllUsers (newValue) {
      this.users = this.allUsers.filter(
        x =>
          x.company == null && (newValue === true || (x.roles !== 'limited' && x.roles !== 'admin'))
      )
    }
  },
  methods: {
    onChangeUserCompanyCheckbox (newValue) {
      this.filter.userId = null
      this.filter.processId = null
      this.filter.answerSetId = null
      this.filter.answerSetGroupId = null
      this.filter.processGroupId = null
      this.yesNoAndPointCheckbox = 'yesno'
      this.processes = []
      this.answerSets = []
      if (newValue === 'company') {
        this.userCompanyCheckboxTitle = this.$t('validation.attributes.company')
        this.onChangeYesNoAndPointCheckbox(this.yesNoAndPointCheckbox)
        this.onChangeParentCompanyUser(this.selectedParentCompanyId)
        this.isCompanyAnswerSet = true
      } else {
        this.userCompanyCheckboxTitle = this.$t('validation.attributes.user')
        this.filter.userId = this.currentUser.id
        this.onChangeUser(this.currentUser.id)
        this.isCompanyAnswerSet = false
      }
    },
    async onChangeYesNoAndPointCheckbox (newValue) {
      this.processes = []
      this.answerSets = []
      this.filter.processGroupId = null
      this.selectedParentProcessGroupId = null

      if (newValue === 'point') {
        this.yesNoAndPointCheckboxTitle = this.$t('title.withPoint')
        this.parentCompanyUsers = this.allUsers.filter(
          d =>
            d.company != null &&
            d.parentCompanyId == null &&
            d.company.permissions &&
            d.company.permissions.includes('processWithPoint')
        )
        await this.getAnswerSetGroups()
      } else {
        this.yesNoAndPointCheckboxTitle = this.$t('title.yesNo')
        this.parentCompanyUsers = this.allUsers.filter(
          d => d.company != null && d.parentCompanyId == null && !d.company.permissions.includes('processWithPoint')
        )
      }
    },
    apply () {
      this.$emit('apply', { filter: this.filter, isGroup: this.yesNoAndPointCheckbox === 'point', isCompanyAnswerSet: this.isCompanyAnswerSet })
    },
    async getProcesses (answerSets) {
      const data = await ApiService.query('/process')
      const processIds = answerSets.map(a => a.processId)
      this.processes = data.filter(p => processIds.includes(p.id))
    },
    async getAnswerSets () {
      this.answerSetsByProcess = []
      this.answerSets = await ApiService.get(`/select/answersets/${this.filter.userId}`)
      await this.getProcesses(this.answerSets)
    },
    async getAnswerSetGroups () {
      this.answerSetGroupsByProcessGroup = []
      this.filter.userId = this.allUsers.filter(
        x => x.company && x.company.id === this.selectedParentCompanyId
      )[0].id
      this.answerSetGroups = await ApiService.get(`/select/answersetgroups/${this.filter.userId}`)
      await this.getProcessGroups(this.answerSetGroups)
    },
    async getProcessGroups (answerSetGroups) {
      const processGroups = await ApiService.query(
        `/select/processgroups/${this.selectedParentCompanyId}`
      )
      const processGroupIds = answerSetGroups.map(a => a.processGroupId)
      this.processGroups = processGroups.filter(p => processGroupIds.includes(p.id))
      this.parentProcessGroups = processGroups.filter(p =>
        this.processGroups.map(x => x.parentProcessGroupId).includes(p.id)
      )
    },
    async getUsers () {
      this.allUsers = await ApiService.get('/select/users')
      this.users = this.allUsers.filter(
        x =>
          x.company == null &&
          (this.isAllUsers === true || (x.roles !== 'limited' && x.roles !== 'admin'))
      )
      if (this.role.admin) {
        this.parentCompanyUsers = this.allUsers.filter(
          d => d.company != null && d.parentCompanyId == null
        )
      } else {
        this.parentCompanyUsers = this.allUsers.filter(
          x => x.company != null && x.id === this.currentUser.id
        )
      }

      await this.onChangeParentCompanyUser()
    },
    onChangeAnswerSet (answerSetId) {
      const selectedAnswerSet = this.answerSets.filter(a => a.id === answerSetId)[0]
      const dateTitle = format(new Date(selectedAnswerSet.submitDate), dateSettings.datetimeFormat)
      this.updateTitle(` _ ${dateTitle}`)
    },
    onChangeAnswerSetGroup (answerSetGroupId) {
      const selectedAnswerSetGroup = this.answerSetGroups.find(a => a.id === answerSetGroupId)
      const dateTitle = format(
        new Date(selectedAnswerSetGroup.submitDate),
        dateSettings.datetimeFormat
      )
      this.updateTitleForProcessGroup(` _ ${dateTitle}`)
    },
    onChangeProcess (processId) {
      this.answerSetsByProcess = []
      this.filter.answerSetId = null
      if (processId) {
        this.answerSetsByProcess = this.answerSets.filter(
          a => a.processId === processId && a.userId === this.filter.userId
        )
        const selectedProcess = this.processes.filter(p => p.id === processId)[0]
        this.filter.content.processName = selectedProcess.name
      }
    },
    onChangeParentProcessGroup (parentProcessGroupId) {
      this.selectedParentProcessGroupId = parentProcessGroupId
      this.filter.processGroupId = null
      this.answerSetGroupsByProcessGroup = []
      this.childProcessGroups = this.processGroups.filter(
        p => p.parentProcessGroupId === parentProcessGroupId
      )
    },
    onChangeProcessGroup (processGroupId) {
      this.answerSetGroupsByProcessGroup = []
      this.filter.answerSetGroupId = null
      if (processGroupId) {
        this.answerSetGroupsByProcessGroup = this.answerSetGroups.filter(
          a => a.processGroupId === processGroupId && a.userId === this.filter.userId
        )
        const selectedProcessGroup = this.processGroups.find(p => p.id === processGroupId)
        this.filter.content.processGroupName = selectedProcessGroup.name
      }
    },
    async onChangeUser (userId) {
      this.filter.processId = null
      this.filter.answerSetId = null
      if (userId) {
        this.filter.userId = userId
        await this.getAnswerSets()
      }
    },
    async onChangeCompanyUser (userId) {
      this.selectedChildCompanyUserId = userId
      this.filter.processId = null
      this.filter.answerSetId = null
      if (userId) {
        this.filter.userId = userId
        await this.getAnswerSets()
      } else {
        await this.onChangeParentCompanyUser(this.selectedParentCompanyId)
      }
    },
    async onChangeParentCompanyUser (companyId) {
      this.selectedChildCompanyUserId = null
      this.filter.processId = null
      this.filter.answerSetId = null
      this.filter.processGroupId = null
      this.filter.answerSetGroupId = null
      if (companyId == null) {
        if (!this.role.admin && this.role.company) {
          companyId = this.currentUser.companyId
        } else if (this.parentCompanyUsers.length > 0) {
          companyId = this.parentCompanyUsers[0].company.id
        }
      }
      if (companyId) {
        this.selectedParentCompanyId = companyId
        this.filter.userId = this.allUsers.filter(
          x => x.company && x.company.id === companyId
        )[0].id
        this.companyUsers = this.allUsers.filter(u => u.parentCompanyId === companyId)
        if (this.yesNoAndPointCheckbox === 'yesno') {
          this.getAnswerSets()
        } else if (this.yesNoAndPointCheckbox === 'point') {
          await this.getAnswerSetGroups()
        }
      }
    },
    updateTitle (expandTitle) {
      const selectedProcess = this.processes.filter(p => p.id === this.filter.processId)[0]
      const selectedUser = this.allUsers.filter(u => u.id === this.filter.userId)[0]
      this.filter.content.title = `${selectedUser.firstname} ${selectedUser.lastname} _ ${selectedProcess.name}`
      this.filter.content.title += expandTitle
    },
    updateTitleForProcessGroup (expandTitle) {
      const selectedProcessGroup = this.processGroups.find(p => p.id === this.filter.processGroupId)
      const selectedUser = this.allUsers.find(u => u.id === this.filter.userId)
      this.filter.content.title = `${selectedUser.firstname} ${selectedUser.lastname} _ ${selectedProcessGroup.name}`
      this.filter.content.title += expandTitle
    }
  }
}
</script>
